import { render, staticRenderFns } from "./MoveInfo.vue?vue&type=template&id=7c4c071c&scoped=true&"
import script from "./MoveInfo.vue?vue&type=script&lang=js&"
export * from "./MoveInfo.vue?vue&type=script&lang=js&"
import style0 from "./MoveInfo.vue?vue&type=style&index=0&id=7c4c071c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4c071c",
  null
  
)

export default component.exports